<template>
  <div class="floating-controls">
    <div class="social-media-icons">
      <a
        href="https://www.facebook.com/Barbershoptalk.posts/"
        class="facebook"
        aria-label="Facebook"
        target="_blank"
        rel="noopener"
      >
        <i class="fa-brands fa-facebook"></i>
      </a>
      <a
        href="https://x.com/barshoptalknews"
        class="x"
        aria-label="X (Twitter)"
        target="_blank"
        rel="noopener"
      >
      <i class="fa-brands fa-twitter"></i>
      </a>
      <a
        href="https://www.instagram.com/barbershoptalknews/"
        class="instagram"
        aria-label="Instagram"
        target="_blank"
        rel="noopener"
      >
        <i class="fa-brands fa-instagram"></i>
      </a>
      <a
        href="https://youtube.com/@barbershoptalk"
        class="youtube"
        aria-label="YouTube"
        target="_blank"
        rel="noopener"
      >
        <i class="fa-brands fa-youtube"></i>
      </a>
    </div>
    <transition name="fade-top-button">
      <button class="to-top-button" @click="scrollUp" aria-label="Scroll to top">
        <i class="fa-solid fa-arrow-up"></i>
        <div class="to-top">
          <p class="visually-hidden">Scroll Up</p>
        </div>
      </button>
    </transition>
  </div>
</template>

<script>
export default {
  name: "ScrollToTopButton",
  methods: {
    scrollUp() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }
};
</script>

<style scoped>
/* Wrapper container for both sets of floating controls */
.floating-controls {
  position: fixed;
  bottom: 97px; /* adjust as needed */
  right: 20px; /* adjust as needed */
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 900;
}

/* Social media icons container */
.social-media-icons {
  display: flex;
  gap: 10px; /* spacing between icons */
  margin-bottom: 10px;
}

/* Default styling for each social media icon link */
.social-media-icons a {
  color: #fff;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.3s;
  text-decoration: none;
}

/* Facebook gradient */
.social-media-icons a.facebook {
  background: linear-gradient(45deg, #1877F2, #3b5998);
}

/* X (Twitter) gradient */
/* Adjusted to use a simple dark/light contrast instead of the sample gradient */
.social-media-icons a.x {
  background: linear-gradient(5deg, black, white);
}

/* Instagram gradient */
.social-media-icons a.instagram {
  background: linear-gradient(45deg, #833AB4, #FD1D1D, #FCAF45);
}

/* YouTube gradient */
.social-media-icons a.youtube {
  background: linear-gradient(45deg, #FF0000, #CC0000);
}

/* Hover effect for social media icons */
.social-media-icons a:hover {
  transform: scale(1.08);
}

/* Scroll to Top Button styles */
.to-top-button {
  width: 50px;
  height: 50px;
  border: none;
  border-radius: 50%;
  background-color: #007bff;
  color: #fff;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  transition: background-color 0.3s, transform 0.3s;
}

/* Remove default button focus outline and replace with custom style if needed */
.to-top-button:focus {
  outline: 2px solid #fff;
  outline-offset: 2px;
}

/* Optional styling: visually hide text but make it available to screen readers */
.visually-hidden {
  position: absolute;
  clip: rect(0 0 0 0);
  width: 1px;
  height: 1px;
  margin: -1px;
  border: 0;
  padding: 0;
  overflow: hidden;
}

/* Hover effect for scroll button */
.to-top-button:hover {
  background-color: #3b9aed;
  transform: scale(1.08);
}

/* Fade transition classes for scroll button */
.fade-top-button-enter-active,
.fade-top-button-leave-active {
  transition: opacity 0.4s;
}
.fade-top-button-enter,
.fade-top-button-leave-to {
  opacity: 0;
}

/* Responsive adjustments */
@media (max-width: 600px) {
  .to-top-button {
    width: 45px;
    height: 45px;
  }
  .floating-controls {
    bottom: calc(92px + env(safe-area-inset-bottom, 0px));
    right: 15px;
  }
}
@media (min-width: 1600px) {
  .to-top-button {
    width: 60px;
    height: 60px;
  }
  .floating-controls {
    bottom: 80px;
    right: 30px;
  }
}
</style>